import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const PARTNER_DASHBOARD_QUERY_KEY = ['GET_PARTNER_DASHBOARD'];

export const useGetPartnerDashboardQuery = () => {
  const { getPartnerDashboard } = useServicesContext();

  return useQuery({
    queryKey: PARTNER_DASHBOARD_QUERY_KEY,
    queryFn: getPartnerDashboard,
  });
};
